import {withDisplayErrorToUser} from "../error/error";
import playgroundApi from "../playgroundApi";
import {store} from "../../redux/store";
import {mySongsPageStore,} from "../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {
  isMySongsPageSelectedSongDetailsRequestReadyToSend
} from "../../pages/songs-router/modules/my-songs-page-store/mySongsPage.selectors";

class SongDetailsPage {
  /** selectors on current store **/
  protected get isReadyToSendLoadRequest(): boolean {
    return isMySongsPageSelectedSongDetailsRequestReadyToSend(store.getState());
  }

  protected async attemptLoad(songId: number) {
    if (!this.isReadyToSendLoadRequest){
      // not ready to load, return to exit
      return;
    }
    // notify is loading
    mySongsPageStore.setSongDetailsRequestStatus(songId, "loading");

    await withDisplayErrorToUser(async () => {
      try {
        // make request
        const response = await playgroundApi.songDetails({songId});

        // notify loading complete
        mySongsPageStore.setSongDetailsRequestStatus(songId, "completed");
        // update store
        mySongsPageStore.loadSongDetails(response.song);
      } catch (e) {
        // notify loading error
        mySongsPageStore.setSongDetailsRequestStatus(songId, "error");
        // throw error so error is output to user
        throw e;
      }
    });
  }

  /** public actions **/
  public async selectSongIdAndAttemptLoad(songId: number) {
    mySongsPageStore.selectSongDetailsById(songId);

    return this.attemptLoad(songId);
  }

  public reset() {
    mySongsPageStore.clearSongDetails();
  }
}

export const songDetailsPage = new SongDetailsPage();
